export const validate = (values) => {
  const errors = {};
  if (!values.role) {
    errors.role = { _error: 'Nama harus diisi' };
  }
  if (!values.userType) {
    errors.userType = { _error: 'Tipe User harus diisi' };
  }
  if (!values.permissions || values?.permissions?.length === 0) {
    errors.permissions  = { _error: 'Permissions harus diisi' };
  }
  return errors;
};
